import React from 'react';
import { css, cx } from '@emotion/css';
const Flex = ({ alignItems = "normal", direction = "row", children, className, gap, inline, justifyContent = "normal", }) => (React.createElement("div", { className: cx(css `
      display: ${inline ? 'inline-flex' : 'flex'};
      flex-direction: ${direction};
      align-items: ${alignItems};
      justify-content: ${justifyContent};
      ${gap ? `gap: ${gap};` : ''}
    `, className) }, children));
export default Flex;
//# sourceMappingURL=Flex.js.map